export default function createArray(N, startAt = 1) {
  return [...Array(N).keys()].slice(startAt);
}

